import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextFieldDate from '../../UI/TextFieldDate';
import Button from '../../UI/Button';
import { confirmAlert } from 'react-confirm-alert';
import { errorMessage, successMessage } from '../../../util/ConfirmAlertUtil';
import { serviceExcludeByDate, serviceIncludeByDate } from '../api-presenca';
import LoadingDialog from '../../UI/LoadingDialog';
import { Divider } from '@mui/material';
import { serviceUpdateByDate, serviceUpdateByDateAndLegendaDiario, serviceUpdateByDateAndTurma } from '../../PresencaAluno/api-presenca-aluno';
import Select from '../../UI/Select';
import { findByAnoLetivo } from '../../Turma/api-turma';
import { findLegendaDiarioAll } from '../../LegendaDiario/api-legenda-diario';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
});

export default function PresencaLoteContainer() {
    const classes = useStyles();
    const [dataInclusao, setDataInclusao] = useState(null);
    const [isLoadingInclusao, setIsLoadingInclusao] = useState(false);
    const [dataExclusao, setDataExclusao] = useState(null);
    const [isLoadingExclusao, setIsLoadingExclusao] = useState(false);
    const [dataAtualizacaoPA, setDataAtualizacaoPA] = useState(null);
    const [isLoadingAtualizacaoPA, setIsLoadingAtualizacaoPA] = useState(false);
    const [dataAtualizacaoPAAndTurma, setDataAtualizacaoPAAndTurma] = useState(null);
    const [dataAtualizacaoPAAndLegendaDiario, setDataAtualizacaoPAAndLegendaDiario] = useState(null);
    const [dataAtualizacaoPAAndTurmaAndLegendaDiario, setDataAtualizacaoPAAndTurmaAndLegendaDiario] = useState(null);
    const [isLoadingAtualizacaoPAAndTurma, setIsLoadingAtualizacaoPAAndTurma] = useState(false);
    const [isLoadingAtualizacaoPAAndLegendaDiario, setIsLoadingAtualizacaoPAAndLegendaDiario] = useState(false);
    // const [isLoadingAtualizacaoPAAndTurmaAndLegendaDiario, setIsLoadingAtualizacaoPAAndTurmaAndLegendaDiario] = useState(false);
    const [codTurma, setCodTurma] = useState(null);
    const [listTurma, setListTurma] = useState([]);
    const [codLegendaDiario, setCodLegendaDiario] = useState(null);
    const [listLegendaDiario, setListLegendaDiario] = useState([]);

    useEffect(() => {
        findByAnoLetivo().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListTurma(
                        data.map((d) => ({
                            value: d.codigo,
                            description: d.descricao
                        })))
                }
            }
        });
        findLegendaDiarioAll().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListLegendaDiario(
                        data.map((d) => ({
                            value: d.codigo,
                            description: d.descricao
                        }))
                    )
                }
            }
        })
    }, []);

    const handleDataInclusaoChange = (data) => {

        setDataInclusao(dayjs(data));
    }

    const handleDataExclusaoChange = (data) => {

        setDataExclusao(dayjs(data));
    }

    const handleDataAtualizacaoPAChange = (data) => {

        setDataAtualizacaoPA(dayjs(data));
    }

    const handleDataAtualizacaoPAAndTurmaChange = (data) => {

        setDataAtualizacaoPAAndTurma(dayjs(data));
    }
    const handleDataAtualizacaoPAAndLegendaDiarioChange = (data) => {

        setDataAtualizacaoPAAndLegendaDiario(dayjs(data));
    }

    const handleDataAtualizacaoPAAndTurmaAndLegendaDiarioChange = (data) => {

        setDataAtualizacaoPAAndTurmaAndLegendaDiario(dayjs(data));
    }

    const handleChangeTurma = (event) => {
        setCodTurma(event.target.value);
    }

    const handleChangeLegendaDiario = (event) => {
        setCodLegendaDiario(event.target.value);
    }

    const handleClickPresencaInclusao = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja Iniciar o Serviço de inlcusão de presença por Data?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingInclusao(true);
                        serviceIncludeByDate(dataInclusao).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    successMessage("Serviço de Inclusão de Datas realizado com sucesso.");
                                }
                            }
                            setIsLoadingInclusao(false);
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleClickPresencaExclusao = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja Iniciar o Serviço de exclusão de presença por Data?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingExclusao(true);
                        serviceExcludeByDate(dataExclusao).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    successMessage("Serviço de Exclusão esta acontecendo em segundo plano.");
                                }
                            }
                            setIsLoadingExclusao(false);
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleClickPresencaAlunoAtualizacao = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja Iniciar o Serviço de atualização de presença aluno por Data?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingAtualizacaoPA(true);
                        serviceUpdateByDate(dataAtualizacaoPA).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    successMessage("Serviço de Atualizacao de Datas realizado com sucesso.");
                                }
                            }
                            setIsLoadingAtualizacaoPA(false);
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }




    const handleClickPresencaAlunoAndTurmaAtualizacao = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja Iniciar o Serviço de atualização de presença aluno por Data e Turma?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingAtualizacaoPAAndTurma(true);
                        serviceUpdateByDateAndTurma(dataAtualizacaoPAAndTurma, codTurma).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    successMessage("Serviço de Atualizacao de Datas e Turma realizado com sucesso.");
                                }
                            }
                            setIsLoadingAtualizacaoPAAndTurma(false);
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }
    const handleClickPresencaAlunoAndLegendaDiarioAtualizacao = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja Iniciar o Serviço de atualização de presença aluno por Data e Legenda Diário?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingAtualizacaoPAAndLegendaDiario(true);
                        serviceUpdateByDateAndLegendaDiario(dataAtualizacaoPAAndLegendaDiario, codLegendaDiario).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    successMessage("Serviço de Atualizacao de Datas e Turma realizado com sucesso.");
                                }
                            }
                            setIsLoadingAtualizacaoPAAndTurma(false);
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }

    return (
        <Container className={classes.paper} component={Paper}>
            <Grid container direction="column" spacing={8}>
                {isLoadingInclusao &&
                    <LoadingDialog
                        openDialog={isLoadingInclusao}
                        setOpenDialog={setIsLoadingInclusao}
                        title="Em processo"
                        description="Serviço de Inclusão de Prensença por data em andamento..."
                    />
                }

                {isLoadingExclusao &&
                    <LoadingDialog
                        openDialog={isLoadingExclusao}
                        setOpenDialog={setIsLoadingExclusao}
                        title="Em processo"
                        description="Serviço de Exclusão de Prensença por data em andamento..."
                    />
                }
                {isLoadingAtualizacaoPA &&
                    <LoadingDialog
                        openDialog={isLoadingAtualizacaoPA}
                        setOpenDialog={setIsLoadingAtualizacaoPA}
                        title="Em processo"
                        description="Serviço de Atualizacao de Prensença Aluno (Presente-Falta) por data em andamento..."
                    />
                }
                {isLoadingAtualizacaoPAAndTurma &&
                    <LoadingDialog
                        openDialog={isLoadingAtualizacaoPAAndTurma}
                        setOpenDialog={setIsLoadingAtualizacaoPAAndTurma}
                        title="Em processo"
                        description="Serviço de Atualizacao de Prensença Aluno (Presente-Falta) por data e turma em andamento..."
                    />
                }
                <Grid size={3}>
                    <Typography variant="h6">
                        Presença Lote
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <Grid container direction="column" spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Inclusão Presença por Data
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataInclusao ? dataInclusao : null}
                                onChange={handleDataInclusaoChange}
                            />
                        </Grid>
                        <Grid>
                            <Button onClick={handleClickPresencaInclusao}>
                                Incluir Prensenças
                            </Button>
                        </Grid>

                    </Grid>

                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid><Divider /></Grid>
                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Exclusão Presença por Data
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataExclusao ? dataExclusao : null}
                                onChange={handleDataExclusaoChange}
                            />
                        </Grid>
                        <Grid>
                            <Button onClick={handleClickPresencaExclusao}>
                                Excluir Prensenças
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid><Divider /></Grid>
                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Atualização Presença Aluno por Data - (Presente-Falta)
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataAtualizacaoPA ? dataAtualizacaoPA : null}
                                onChange={handleDataAtualizacaoPAChange}
                            />
                        </Grid>
                        <Grid>
                            <Button onClick={handleClickPresencaAlunoAtualizacao}>
                                Atualizar Prensença Aluno
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid><Divider /></Grid>
                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Atualização Presença Aluno por Data e Turma - (Presente-Falta)
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataAtualizacaoPAAndTurma ? dataAtualizacaoPAAndTurma : null}
                                onChange={handleDataAtualizacaoPAAndTurmaChange}
                            />
                        </Grid>
                        <Grid>
                            <Select
                                label="Turmas"
                                value={codTurma}
                                list={listTurma}
                                onChange={handleChangeTurma}
                            />
                        </Grid>
                        <Grid>
                            <Button onClick={handleClickPresencaAlunoAndTurmaAtualizacao}>
                                Atualizar Prensença Aluno
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid><Divider /></Grid>
                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Atualização Presença Aluno por Data e Legenda Diário
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataAtualizacaoPAAndLegendaDiario ? dataAtualizacaoPAAndLegendaDiario : null}
                                onChange={handleDataAtualizacaoPAAndLegendaDiarioChange}
                            />
                        </Grid>
                        <Grid>
                            <Select
                                label="Legenda Diário"
                                value={codLegendaDiario}
                                list={listLegendaDiario}
                                onChange={handleChangeLegendaDiario}
                            />
                        </Grid>
                        <Grid>
                            <Button
                                isLoadingAction={isLoadingAtualizacaoPAAndLegendaDiario}
                                onClick={handleClickPresencaAlunoAndLegendaDiarioAtualizacao}>
                                Atualizar Prensença Aluno
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid><Divider /></Grid>
                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container direction='column' spacing={3}>
                        <Grid>
                            <Typography variant="body1">
                                Atualização Presença Aluno por Data, Turma e Legenda Diário
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextFieldDate
                                required
                                label="Data"
                                value={dataAtualizacaoPAAndTurmaAndLegendaDiario ? dataAtualizacaoPAAndTurmaAndLegendaDiario : null}
                                onChange={handleDataAtualizacaoPAAndTurmaAndLegendaDiarioChange}
                            />
                        </Grid>
                        <Grid>
                            <Select
                                label="Legenda Diário"
                                value={codLegendaDiario}
                                list={listLegendaDiario}
                                onChange={handleChangeLegendaDiario}
                            />
                        </Grid>
                        <Grid>
                            <Button
                                isLoadingAction={isLoadingAtualizacaoPAAndLegendaDiario}
                                onClick={handleClickPresencaAlunoAndLegendaDiarioAtualizacao}>
                                Atualizar Prensença Aluno
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>
        </Container>
    );
}